
























import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';

import GlobalFooter from '@/components/globalfooter/Index.vue';

@Component({
    components: {
        GlobalFooter,
    },
})
export default class PassportLayout extends Vue {

    private links: any[] = [{
            title: '帮助',
            href: '//www.jianshu.com/u/f6ef3106bada',
            blankTarget: true,
        },
        {
            title: '隐私',
            href: '//www.jianshu.com/u/f6ef3106bada',
            blankTarget: true,
        },
        {
            title: '条款',
            href: '//www.jianshu.com/u/f6ef3106bada',
            blankTarget: true,
        },
    ];
    constructor() {
        super();
    }

}
